import { fmtBRL } from "@/lib/api";
import { LifeBuoy } from "lucide-react";
import { Link } from "react-router-dom";

const groups = [
  ["d7", "Vencidos há 1–7 dias", "chance alta de renovar", "#FBBF24"],
  ["d30", "Vencidos há 8–30 dias", "precisam de contato", "#F87171"],
  ["older", "Mais de 30 dias", "perda provável", "#64748B"],
];

export const RecoverCard = ({ recover, counts = false, onOpen }) => (
  <div data-testid="card-a-recuperar-detalhe" className="lg:col-span-4 rounded-2xl border border-[#1F293D] bg-[#111827] p-5 fade-up" style={{ animationDelay: "160ms" }}>
    <h3 className="mb-4 flex items-center gap-2 text-sm font-semibold uppercase tracking-wider text-slate-200">
      <LifeBuoy className="h-4 w-4 text-rose-400" /> A recuperar
    </h3>
    <div className="space-y-3">
      {groups.map(([k, label, hint, color]) => (
        <div key={k} data-testid={`recuperar-${k}`} role={onOpen ? "button" : undefined} onClick={onOpen ? () => onOpen(k, label) : undefined}
          className={`rounded-xl border border-[#1F293D] bg-[#0F141F] p-3 transition-colors hover:border-[#334155] ${onOpen ? "cursor-pointer hover:bg-[#131b2b]" : ""}`}>
          <div className="flex items-center justify-between">
            <span className="flex items-center gap-2 text-sm text-slate-300">
              <span className="h-2 w-2 rounded-full" style={{ background: color }} /> {label}
            </span>
            {!counts && <span className="font-mono text-xs text-slate-500">{recover[k].count.toLocaleString("pt-BR")} logins</span>}
          </div>
          <div className="mt-1 flex items-end justify-between">
            <span data-testid={`recuperar-${k}-valor`} className="font-mono text-xl font-bold" style={{ color }}>
              {counts ? `${recover[k].count.toLocaleString("pt-BR")} clientes` : fmtBRL(recover[k].amount)}</span>
            <span className="text-[11px] text-slate-500">{onOpen ? "ver lista →" : hint}</span>
          </div>
        </div>
      ))}
    </div>
    <Link to="/faturas" data-testid="recuperar-ver-faturas" className="mt-4 block text-center text-xs font-semibold text-sky-400 hover:text-sky-300">
      Ver cobranças em aberto →
    </Link>
  </div>
);
